import type { EventRaw, SpillEvent } from './types';

export class EventKatalog {
  private _events: SpillEvent[] = [];
  private _loaded = false;

  loadFromArray(raw: EventRaw[]): void {
    this._events = raw
      .filter((e): e is EventRaw => !!e && !!e.id && !!e.kategori && !!e.tittel)
      .filter((e) => Array.isArray(e.valg) && e.valg.length >= 1)
      .map((e) => ({ ...e, valg: e.valg.map((v) => ({ ...v, konsekvenser: { ...v.konsekvenser } })) }));
    this._loaded = true;
  }

  get isReady(): boolean {
    return this._loaded;
  }

  get events(): SpillEvent[] {
    return this._events.map((e) => this.cloneEvent(e));
  }

  findById(id: string): SpillEvent | undefined {
    const e = this._events.find((x) => x.id === id);
    return e ? this.cloneEvent(e) : undefined;
  }

  private cloneEvent(e: SpillEvent): SpillEvent {
    return {
      ...e,
      trigger: e.trigger ? { ...e.trigger } : undefined,
      valg: e.valg.map((v) => ({ tekst: v.tekst, konsekvenser: { ...v.konsekvenser } })),
    };
  }
}

export const eventKatalog = new EventKatalog();
